import React              from 'react';
import ReactDOM           from 'react-dom';
import './index.css';
import { AppRoot }                from './app';
import { CustomerConfig } from "./types";

const customer = process.env.STC_CUSTOMER;

console.log("App version", require('../package.json').version);

if(customer) {
    const config = require(`../customers/${customer}`).default as CustomerConfig;

    ReactDOM.render(
        <AppRoot config={config}/>,
        document.getElementById('root')
    );
}